import { QueryClient as z } from './contact-channels73.js';

const t=new z;

export { t as queryClient };
//# sourceMappingURL=contact-channels62.js.map
